import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PackageScanDto, OrderManagementBatch, BatchDuplicateCheckDto, AjaxResponseOfBatchDuplicateCheckDto, DuplicateSerialNoCheckRequestDto } from 'shared/service-clients/om-batch';
import { AjaxResponse } from 'shared/service-clients/om-order';

// Also known as the Tenant Service
@Injectable()
export class BatchService {

  constructor(
    private omBatchClient: OrderManagementBatch
  ) { }

  saveScan(packageScanDto: PackageScanDto): Observable<AjaxResponse> {
    return this.omBatchClient.recordPakageScanForBatch(packageScanDto);
  }

  checkForDuplicates(duplicateDto: DuplicateSerialNoCheckRequestDto): Observable<AjaxResponseOfBatchDuplicateCheckDto> {
    return this.omBatchClient.checkForDuplicates(duplicateDto);
  }

  extractValuesFromScan(scan: string, serialNumberLength: number): DataMatrixExtract {
    //console.log('to extract ' + scan);    
    if (!scan) {
      return null;
    }
    //console.log('scanned ' + scan);
    let extract: DataMatrixExtract = new DataMatrixExtract();

    // Check for 4-part DataMatrix scan expirationDate and lot in sequence
    const dataMatrixPattern = new RegExp(`^(01|00)(\\d{14})21([A-Za-z0-9]{${serialNumberLength}})17(\\d{6})10(\\S+)$`);
    const dataMatrixMatch = scan.match(dataMatrixPattern);
    if (dataMatrixMatch) {
      extract.gtin = dataMatrixMatch[2];
      extract.serial = dataMatrixMatch[3];
      extract.expiration = dataMatrixMatch[4];
      extract.lot = dataMatrixMatch[5];
      return extract;
    }
    else {
      console.log('4 part Not found ' + scan);
    }

    // Check for 4-part DataMatrix scan lot and expirationDate in sequence
    const dataMatrixPatternLotExpiration = new RegExp(`^(01|00)(\\d{14})21([A-Za-z0-9]{${serialNumberLength}})10(\\S+)17(\\d{6})$`);
    const dataMatrixMatchLotExpiration = scan.match(dataMatrixPatternLotExpiration);
    if (dataMatrixMatchLotExpiration) {
      extract.gtin = dataMatrixMatchLotExpiration[2];
      extract.serial = dataMatrixMatchLotExpiration[3];
      extract.expiration = dataMatrixMatchLotExpiration[5];
      extract.lot = dataMatrixMatchLotExpiration[4];
      return extract;
    }
    else {
      console.log('4 part Not found ' + scan);
    }

    // Check for 2-part barcode scan
    const barcodePattern = new RegExp(`^(01|00)(\\d{14})21(\\S{${serialNumberLength}})$`);
    const barcodeMatch = scan.match(barcodePattern);
    if (barcodeMatch) {
      extract.gtin = barcodeMatch[2];
      extract.serial = barcodeMatch[3];
      return extract;
    }
    else {
      console.log('2 part Not found ' + scan);
    }

    return null;
  }

  extractSSCCFromScan(scan: string): SSCCOutput {
    if (!scan) {
      return null;
    }
    const manufacturerSsccPattern = /^00(.{18})$/;
    const knipperPattern = /^(.{18})$/;
    let extract: SSCCOutput = new SSCCOutput();

    if (scan.match(manufacturerSsccPattern)) {
      extract.isManufacturerSSCC = true;
      extract.sscclabel = scan.match(manufacturerSsccPattern)[1];
      extract.matchDigitLabel = scan.match(manufacturerSsccPattern)[1]
    } else if (scan.match(knipperPattern)) {
      extract.isKnipperSSCC = true;
      extract.sscclabel = scan;
    } else {
      // If the input is not 18 characters long, it is invalid.
      extract.sscclabel = null;
    }
    return extract;
  }
}

export class Item {
  value: any;
  label: string;

  constructor(value, label) {
    this.value = value;
    this.label = label;
  }
}

export class DataMatrixExtract {
  gtin: string;
  lot: string;
  expiration: string;
  serial: string;
}

export class SSCCOutput {
  sscclabel: string;
  isManufacturerSSCC: boolean = false;
  isKnipperSSCC: boolean = false;
  matchDigitLabel: string;
}
